<template>
  <v-dialog
    v-model="dialog"
    width="328px">
    <div class="dialog-container">
      <h2>Refund Partial/All</h2>
      <p>Price charged for the original endorsementxiaw
      </p>
      <div class="table">
        <div class="tr th">
          <span>Item</span>
          <span>Amount</span>
        </div>
        <div class="tr">
          <span>Previous Remaining Premium</span>
          <span></span>
        </div>
        <div class="tr">
          <span>New Remaining Premium</span>
          <span></span>
        </div>
        <div class="tr">
          <span>Admin Charge</span>
          <span></span>
        </div>
        <div class="tr">
          <span>Payable</span>
          <span></span>
        </div>
      </div>
      <div class="form-item">
        <span>Amount To Be Refunded</span>
        <v-input prepend="$" />
      </div>
      <div class="flex-sb">
        <div>
          <v-button @click="handlerCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerAdd">Add to Policy Cheques</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
export default {
  name: 'Refund',
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCancel() {
      this.dialog = false
    },
    handlerAdd() {
      this.dialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      p {
        padding-bottom: 10px;
        font-size: 16px;
      }
    }
</style>